<template>
  <div>
    <div class="card" style="padding: 2%">
      <div class="modal-header" style="padding: 0px">
        <div class="row">
          <div class="col-md-10">
            <p>
              <!-- <i
                class="fa fa-calendar text-success"
                style="font-size: 26px"
              ></i> -->
             <span style="font-weight: 600; font-size: 20px;">Calendario de programación</span> <br>
             <span style="font-size: 14px; color:grey">Gestiona las sesiones de los pacientes</span>
            </p>
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-success btn-fill btn-block"
              style="border-radius: 5px"
              @click="abrirModal()"
            >
              Registrar una programación
            </button>
            <br />
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-md-4">
            <label for="ver_eventos_desde">Ver eventos desde:</label>
            <select id="ver_eventos_desde" v-model="desde" class="form-control" @change="setearEventos()">
              <option value="7">Hace una semana</option>
              <option value="15">Hace 15 días</option>
              <option value="30">Hace 1 mes</option>
              <option value="60">Hace 2 meses</option>
            </select>
          </div>
          <div class="col-md-4">
            <label for="ver_eventos_de">Ver eventos de:</label>
            <select
              id="ver_eventos_de"
              v-model="terapeutaEventos"
              class="form-control"
              @change="setearEventos()"
            >
              <option value="todos">Todos los eventos</option>
              <option
                v-for="Terapeuta in arrayTerapeutas"
                :key="Terapeuta.usuario"
                :value="Terapeuta.usuario"
              >
                {{ Terapeuta.nombres }} {{ Terapeuta.apellidos }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div id="calendarEl">
              <br />
              <template>
                <FullCalendar
                  defaultView="listWeek"
                  :hiddenDays="[]"
                  :locale="'esLocale'"
                  :plugins="calendarPlugins"
                  :events="arrayEventos"
                  :header="headers"
                  @eventClick="verEvento"
                  ref="fullCalendar"
                >
                </FullCalendar>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal
      name="ingresar_programacion"
      id="modal"
      height="800"
      width="1500"
      :clickToClose="false"
    >
      <header class="modal-header">
        <div class="row">
          <div class="col-md-7">
            <p>
              <!-- <i class="fa fa-calendar"></i> -->
              <span style="font-weight: 600; font-size: 20px;">Programación de citas</span>
            </p>
          </div>
          <div class="col-md-5 pull-lefth">
            <button
              @click="cerrarModal('ingresar_programacion')"
              type="button"
              class="close btn btn-danger btn-simple btn-icon"
              data-dismiss="modal"
              aria-label="Close"
              style="color: red"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </header>
      <div
        style="padding: 10px 30px 30px 30px; height: 83%; overflow-y: scroll"
        class="modal-body"
      >
        <!-- Titulo -->

        <!-- Formulario para buscar pacientes -->
        <form @submit.prevent="buscarPaciente">
          <br />
          <div class="row">
            <div class="col-md-12">
              <p style="font-weight: bold">Buscar paciente</p>
            </div>
            <div class="col-12 col-xs-12 col-md-4">
              <select v-model="formPaciente.criterio" class="form-control">
                <option value="paciente.PacApe1">
                  <i class="fa fa-user"></i> Apellidos del paciente
                </option>
                <option value="paciente.PacNom1">Nombres del paciente</option>
                <option value="paciente.PacNumDoc">
                  Documento del paciente
                </option>
              </select>
            </div>
            <div class="col-12 col-xs-12 col-md-6">
              <input
                required
                type="text"
                id="texto"
                v-model="formPaciente.busqueda"
                class="form-control"
                placeholder="Buscar..."
              />
            </div>
            <div class="col-12 col-xs-12 col-md-2">
              <button
                type="submit"
                style="border-radius: 5px"
                class="btn btn-block btn-success btn-fill"
              >
                <i class="fa fa-search"></i> Buscar
              </button>
            </div>
            <div class="col-md-1"></div>
          </div>
        </form>

        <!-- tabla de pacientes encontrados -->
        <br />
        <div class="row" v-if="arrayPacientes.length > 0">
          <div class="col-md-12">
            <p style="font-weight: bold">Pacientes encontrados</p>
          </div>
          <center>
            <div>
              <el-table
                :data="arrayPacientes"
                border
                size="mini"
                style="width: 97%"
                class="table-responsive"
              >
                <el-table-column type="index" label="#"></el-table-column>
                <el-table-column
                  prop="PacApe1"
                  label="Apellidos"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="PacNom1"
                  label="Nombres"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="PacNumDoc"
                  label="N° documento"
                  align="center"
                ></el-table-column>
                <!-- <el-table-column prop="TipCliNom" label="Tipo de cliente" align="center"></el-table-column> -->
                <el-table-column label="Acción" width="270" align="center">
                  <template slot-scope="props">
                    <!-- <center>
                      <button
                        v-if="props.row.estadoProgramacion === 'Disponible programar'"
                        @click="seleccionarPaciente(props.row)"
                        class="btn btn-sm btn-fill btn-success btn-xs btn-icon like"
                      >
                        Seleccionar
                      </button>
                      <span v-else class="text-danger"> {{ props.row.estadoProgramacion }} </span>
                    </center> -->
                    <center>
                      <button
                        @click="seleccionarPaciente(props.row)"
                        class="btn btn-sm btn-fill btn-success btn-xs btn-icon like"
                      >
                        Seleccionar
                      </button>
                    </center>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </center>
        </div>

        <!-- Informacion del paciente seleccionado -->
        <br />
        <div class="row" v-if="pacienteSeleccionado.documento != ''">
          <div class="col-md-12">
            <p style="font-weight: bold">Paciente seleccionado</p>
          </div>
          <div class="col-md-6">
            <label style="font-weight: 500" for>Nombre</label>
            <input
              type="text"
              class="form-control input-sm"
              disabled
              :value="pacienteSeleccionado.nombre"
            />
          </div>
          <div class="col-md-4">
            <label style="font-weight: 500" for>Documento</label>
            <input
              type="text"
              class="form-control input-sm"
              disabled
              :value="pacienteSeleccionado.documento"
            />
          </div>
          <center class="col-md-2 text-success">
            <label for>Cod. único</label>
            <p style="font-size: 19px">{{ pacienteSeleccionado.ide }}</p>
          </center>
        </div>

        <!-- tabla de servicios autorizados al paciente -->
        <br />
        <!-- <div class="row" v-if="servicioSeleccionado.ide != ''">
          <div class="col-md-12">
            <button class="btn btn-fill btn-sm btn-danger" style="border-radius: 5px;" @click="servicioSeleccionado.ide = ''"> <i class="fa fa-arrow-left"></i> Seleccionar otro servicio </button>
          </div>
        </div> -->
        <div
          class="row"
          v-if="
            arrayServiciosDisponibles != '' && servicioSeleccionado.id == ''
          "
        >
          <div class="col-md-12">
            <p style="font-weight: bold">Autorizaciones</p>
          </div>
          <center>
            <div>
              <el-table
                :data="arrayServiciosDisponibles"
                border
                size="mini"
                style="width: 97%"
                class="table-responsive"
              >
                <el-table-column type="index" label="#"></el-table-column>
                <el-table-column
                  prop="codigo"
                  label="Codigo de autorización"
                  align="center"
                ></el-table-column>
                <el-table-column label="Especialidad" width="150" align="center">
                  <template slot-scope="props">
                    <span style="background-color: #E3097E; color: white; padding: 5px; border-radius: 7px; font-weight: 600;">
                      {{ labelEspecialidad[props.row.especialidad] }}
                    </span>
                  </template> 
                </el-table-column>
                <el-table-column
                  prop="fechaExpedicion"
                  label="Fecha de expedición"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="fechaVencimiento"
                  label="Fecha de vencimiento"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="bolsa"
                  label="Bolsa actual"
                  align="center"
                ></el-table-column>
                <!-- <el-table-column prop="TipCliNom" label="Tipo de cliente" align="center"></el-table-column> -->
                <el-table-column label="Acción" width="100" align="center">
                  <template slot-scope="props">
                    <center>
                      <button
                        :disabled="props.row.bolsa < 1"
                        @click="seleccionarServicio(props.row)"
                        class="btn btn-simple btn-success btn-xs btn-icon like"
                      >
                        Seleccionar
                      </button>
                    </center>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </center>
        </div>

        <!-- Informacion del paciente seleccionado -->
        <br />
        <div class="row" v-if="servicioSeleccionado.id != ''">
          <div class="col-md-12">
            <p style="font-weight: bold">Servicio Seleccionado</p>
          </div>
          <div class="col-md-3">
            <label style="font-weight: 500" for>Autorización</label>
            <input
              type="text"
              class="form-control input-sm"
              disabled
              :value="servicioSeleccionado.codigo"
            />
          </div>
          <div class="col-md-3">
            <label style="font-weight: 500" for>Sesiones Autorizadas</label>
            <input
              type="text"
              class="form-control input-sm"
              disabled
              :value="servicioSeleccionado.sesionesAutorizadas"
            />
          </div>
        </div>

        <!-- Tipos de programaciones -->
        <br />
        <div class="row" v-if="servicioSeleccionado.id != ''">
          <div class="col-md-12">
            <p style="font-weight: bold">Tipo de programación:</p>
            <div class="col-md-2">
              <input type="radio" value="1" id="unica" v-model="formato" /> <label for="unica">Única</label>
            </div>
            <div class="col-md-2">
              <input type="radio" id="especialidad" value="3" v-model="formato" /> <label for="especialidad">Por especialidad</label>
            </div>
          </div>
        </div>

        <!-- Programacion -->
        <br />
        <div v-if="servicioSeleccionado.id != '' && formato == 2">
          <form>
            <br />
            <div class="row" style="padding: 0 10px">
              <div class="col-md-12">
                <p style="font-weight: bold">Programación</p>
              </div>
              <div class="col-12 col-xs-12 col-md-6">
                <label style="font-weight: 500" for>Terapeuta</label>
                <select name class="form-control" v-model="terapeutaProgramar">
                  <option
                    v-for="Terapeuta in arrayTerapeutas"
                    :key="Terapeuta.usuario"
                    :value="Terapeuta.usuario"
                  >
                    {{ Terapeuta.nombres }} {{ Terapeuta.apellidos }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-xs-12 col-md-6">
                <label style="font-weight: 500" for>Lugar</label>

                <select
                  name
                  class="form-control"
                  v-model="programacionIndividual.lugar"
                  required
                >
                  <option value="Sede">Sede</option>
                  <option value="Domicilio">Domicilio</option>
                  <option value="Virtual">Virtual</option>
                </select>
              </div>
            
            <div class="col-md-3">
                <label for="valor">{{  servicioSeleccionado.tipo == 'particular' ? 'Valor por sesión' : 'Servicio'  }}</label>
                <input
                  v-if="servicioSeleccionado.tipo == 'particular'"
                  type="number"
                  id="valor"
                  v-model="programacionIndividual.valorSesion"
                  class="form-control"
                  required
                />

                <select class="form-control" id="valor" v-else v-model="programacionIndividual.valorSesion">
                  <option v-for="tarifa in arrayServiciosConTarifa"
                  :key="tarifa.id"
                  :value="tarifa"> {{ tarifa.especialidad }}  </option>
                </select>
              </div>
              <!-- <div class="col-md-3" v-if="servicioSeleccionado.tipo != 'particular'">
                <label for="valor">Copago</label>
                <input
                  
                  type="number"
                  id="valor"
                  v-model="programacionIndividual.copago"
                  class="form-control"
                  required
                />
              </div> -->
              <br>
            </div>
            <div class="row" style="padding: 0 10px">
              <br>
              <div class="col-12 col-xs-12 col-md-6">
                <label for="fechaInicioSesiones"
                  >Fecha inicio de las sesiones</label
                >
                <input
                  :min="calcularFechaActual()"
                  :max="servicioSeleccionado.fechaVencimiento"
                  required
                  v-model="iniciosesiones"
                  type="date"
                  id="fechaInicioSesiones"
                  class="form-control"
                />
              </div>
              <div class="col-12 col-xs-12 col-md-6">
                <label for="fechaFinSesiones">Fecha fin de las sesiones</label>
                <input
                  :min="iniciosesiones"
                  :max="servicioSeleccionado.fechaVencimiento"
                  required
                  v-model="finsesiones"
                  type="date"
                  id="fechaFinSesiones"
                  class="form-control"
                />
              </div>
            </div>

            <br />
            <div class="row" style="padding: 0 10px">
              <div class="col-md-12">
                <h5>Seleccione los dias a programar</h5>
              </div>
              <div class="col-12 col-xs-12 col-md-12">
                <div class="col-md-3">
                  <br />
                  <p>LUNES</p>
                </div>
                <div class="col-md-3">
                  <label for="l_horainicio">Hora inicio</label>
                  <input
                    type="time"
                    id="l_horainicio"
                    v-model="diasProgramacion.lunes.horainicio"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label for="l_horafin">Hora fin</label>
                  <input
                    type="time"
                    id="l_horafin"
                    v-model="diasProgramacion.lunes.horafin"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-12 col-xs-12 col-md-12">
                <div class="col-md-3">
                  <br />
                  <p>MARTES</p>
                </div>
                <div class="col-md-3">
                  <label for="m_horainicio">Hora inicio</label>
                  <input
                    type="time"
                    id="m_horainicio"
                    v-model="diasProgramacion.martes.horainicio"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label for="m_horafin">Hora fin</label>
                  <input
                    type="time"
                    id="m_horafin"
                    v-model="diasProgramacion.martes.horafin"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-12 col-xs-12 col-md-12">
                <div class="col-md-3">
                  <br />
                  <p>MIERCOLES</p>
                </div>
                <div class="col-md-3">
                  <label for="x_horainicio">Hora inicio</label>
                  <input
                    type="time"
                    id="x_horainicio"
                    v-model="diasProgramacion.miercoles.horainicio"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label for="x_horafin">Hora fin</label>
                  <input
                    type="time"
                    id="x_horafin"
                    v-model="diasProgramacion.miercoles.horafin"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-12 col-xs-12 col-md-12">
                <div class="col-md-3">
                  <br />
                  <p>JUEVES</p>
                </div>
                <div class="col-md-3">
                  <label for="j_horainicio">Hora inicio</label>
                  <input
                    type="time"
                    id="j_horainicio"
                    v-model="diasProgramacion.jueves.horainicio"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label for="j_horafin">Hora fin</label>
                  <input
                    type="time"
                    id="j_horafin"
                    v-model="diasProgramacion.jueves.horafin"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-12 col-xs-12 col-md-12">
                <div class="col-md-3">
                  <br />
                  <p>VIERNES</p>
                </div>
                <div class="col-md-3">
                  <label for="v_horainicio">Hora inicio</label>
                  <input
                    type="time"
                    id="v_horainicio"
                    v-model="diasProgramacion.viernes.horainicio"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label for="v_horafin">Hora fin</label>
                  <input
                    type="time"
                    id="v_horafin"
                    v-model="diasProgramacion.viernes.horafin"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-12 col-xs-12 col-md-12">
                <div class="col-md-3">
                  <br />
                  <p>SABADO</p>
                </div>
                <div class="col-md-3">
                  <label for="s_horainicio">Hora inicio</label>
                  <input
                    type="time"
                    id="s_horainicio"
                    v-model="diasProgramacion.sabado.horainicio"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label for="s_horafin">Hora fin</label>
                  <input
                    type="time"
                    id="s_horafin"
                    v-model="diasProgramacion.sabado.horafin"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- Programacion Unica-->
        <br />
        <div v-if="servicioSeleccionado.id != '' && formato != 2">
          <form>
            <br />
            <div class="row" style="padding: 0 10px">
              <div class="col-md-12">
                <p style="font-weight: bold">Programación</p>
              </div>
              <div class="col-6 col-xs-6 col-md-6">
                <label style="font-weight: 500" for>Terapeuta</label>
                <select
                  name
                  class="form-control"
                  v-model="terapeutaProgramar"
                  required
                >
                  <option
                    v-for="Terapeuta in arrayTerapeutas"
                    :key="Terapeuta.usuario"
                    :value="Terapeuta.usuario"
                  >
                    {{ Terapeuta.nombres }} {{ Terapeuta.apellidos }}
                  </option>
                </select>
              </div>
              <div class="col-6 col-xs-6 col-md-3">
                <label style="font-weight: 500" for>Tipo de sesión</label>
                <select
                  name
                  class="form-control"
                  v-model="programacionIndividual.tipo"
                  required
                >
                  <option value="Terapia">Terapia</option>
                  <option value="Evaluacion">Evaluación</option>
                  <option value="CYT">CYT</option>
                </select>
              </div>

              <div class="col-6 col-xs-6 col-md-3">
                <label style="font-weight: 500" for>Lugar</label>
                <select
                  name
                  class="form-control"
                  v-model="programacionIndividual.lugar"
                  required
                >
                  <option value="Sede">Sede</option>
                  <option value="Domicilio">Domicilio</option>
                  <option value="Virtual">Virtual</option>
                </select>
              </div>
            </div>

            <br />
            <div class="row" style="padding: 0 10px">
              <div class="col-12 col-xs-12 col-md-6">
                <label for="fechaInicioSesiones">Fecha de la sesión</label>
                <input
                  :min="calcularFechaActual()"
                  :max="servicioSeleccionado.fechaVencimiento"
                  required
                  v-model="programacionIndividual.fecha"
                  type="date"
                  id="fechaInicioSesiones"
                  class="form-control"
                />
              </div>
              <div class="col-md-3">
                <label for="l_horainicio">Hora inicio</label>
                <input
                  type="time"
                  id="l_horainicio"
                  v-model="programacionIndividual.horainicio"
                  class="form-control"
                  required
                  @change="validarHoraInicio"
                />
              </div>
              <div class="col-md-3">
                <label for="l_horafin">Hora fin</label>
                <input
                  type="time"
                  id="l_horafin"
                  v-model="programacionIndividual.horafin"
                  class="form-control"
                  @change="validarHoraFin"
                  required
                />
              </div>
              <div class="col-md-3">
                <label for="valor">{{  servicioSeleccionado.tipo == 'particular' ? 'Valor por sesión' : 'Servicio'  }}</label>
                <input
                  v-if="servicioSeleccionado.tipo == 'particular'"
                  type="number"
                  id="valor"
                  v-model="programacionIndividual.valorSesion"
                  class="form-control"
                  required
                />

                <select class="form-control" id="valor" v-else v-model="programacionIndividual.valorSesion">
                  <option v-for="tarifa in arrayServiciosConTarifa"
                  :key="tarifa.id"
                  
                  :value="tarifa"> {{ tarifa.especialidad }}  </option>
                </select>
              </div>
              <!-- <div class="col-md-3" v-if="servicioSeleccionado.tipo != 'particular'">
                <label for="valor">Copago</label>
                <input
                  type="number"
                  id="valor"
                  
                  v-model="programacionIndividual.copago"
                  class="form-control"
                  required
                />
              </div> -->
            </div>
          </form>
          <div class="row" style="padding: 10px; margin-top:10px;" v-if="formato == 3 && arrayProgramacionEspecialidad.length > 0">
            <div class="col-md-3">
              <label for="cantses">Cantidad de sesiones a programar</label>
              <input type="text" id="cantses" class="form-control" readonly disabled :value="contadorSesionesEspecialidad">
              <br>
            </div>
            <br>
            <div class="col-md-12">
              <br>
              <table class="table table-striped table-hover table-bordered">
              <tr style="background-color: #E3097E; color:white;">
                <th style="padding:10px;">Terapeuta</th>
                <th style="padding:10px;">Fecha</th>
                <th style="padding:10px;">Hora Inicio</th>
                <th style="padding:10px;">Hora Fin</th>
                <th style="padding:10px;">Acciones</th>
              </tr>
              <tr v-for="(terapia, index) in arrayProgramacionEspecialidad" :key="index">
                <td style="padding:10px">{{ terapia.terapeuta }}</td>
                <td style="padding:10px">{{terapia.fecha | date}}</td>
                <td style="padding:10px">{{terapia.horainicio}}</td>
                <td style="padding:10px">{{terapia.horafin}}</td>
                <td style="padding:10px"> 
                  <center>
                    <button style="border-radius: 7px;" class="btn btn-success btn-icon" @click="eliminarProgramacionDeLaLista(index)"> <i class="fa fa-trash"></i> </button> 
                  </center>
                </td> 
              </tr>
            </table>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer" style="padding-bottom: 0">
        <center>
          <button @click="adicionarProgramacion()" type="button" v-if="formato == 3" style="border-radius: 5px" class="btn btn-primary btn-fill">
            <i class="fa fa-plus"></i> Adicionar programación
          </button>
          <button
            @click="enviarProgramacion()"
            type="button"
            v-if="servicioSeleccionado.id != ''"
            style="border-radius: 5px"
            class="btn btn-success btn-fill"
          >
            <i class="fa fa-send"></i> Enviar programación
          </button>
        </center>
      </div>
    </modal>
    <modal
      name="detalle_terapia"
      id="modal"
      height="auto"
      width="550"
      :clickToClose="false"
    >
      <header class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-7">
            <strong>Detalle de la terapia:</strong>
          </div>
          <div class="col-md-5 pull-lefth">
            <button
              @click="cerrarModal('detalle_terapia')"
              type="button"
              class="close btn btn-danger btn-simple btn-icon"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" style="color: red">&times;</span>
            </button>
          </div>
        </div>
      </header>
      <section
        class="modal-body"
        style="padding: 8px"
        v-if="eventoSeleccionado != ''"
      >
        <div class="row">
          <div class="col-md-12">
            <h4>
              <i class="fa fa-user"></i> {{ eventoSeleccionado.title }} -
              {{ eventoSeleccionado.extendedProps.documentoPaciente }}
            </h4>
            <small
              v-if="
                actionModal === 'detalle' || actionModal != 'actualizar horario'
              "
            >
              <i class="fa fa-calendar"></i> El
              <strong
                >{{ eventoSeleccionado.extendedProps.fecha | date }}
              </strong>
              de
              <strong>{{ eventoSeleccionado.extendedProps.horainicio }}</strong>
              a <strong>{{ eventoSeleccionado.extendedProps.horafin }}</strong>
              <button
                v-if="
                  eventoSeleccionado.extendedProps.tipo != 'CYT' &&
                  eventoSeleccionado.extendedProps.estadoEvento === 3
                "
                class="btn btn-xs btn-fill btn-info"
                @click="actionModal = 'actualizar horario'"
              >
                Actualizar horario
              </button>
            </small>
            <div class="row" v-if="actionModal === 'actualizar horario'">
              <div class="col-md-12">
                <small>Actualizar la hora de la sesión</small>
              </div>
              <div class="col-md-4">
                <input
                  class="form-control input-sm"
                  type="time"
                  @change="adicionarHoras()"
                  v-model="actualizarhorainicio"
                />
              </div>
              <div class="col-md-1">a</div>
              <div class="col-md-4">
                <input
                  class="form-control input-sm"
                  type="time"
                  disabled
                  v-model="actualizarhorafin"
                />
              </div>
            </div>
            <br />
            <small>
              <i class="fa fa-calendar"></i>
              {{ eventoSeleccionado.extendedProps.cantidadSesiones * 30 }}
              minutos
            </small>
            <!-- <p>
              <i class="fa fa-file"></i>
              
            </p> -->
          </div>
        </div>
        <div class="row">
          <!-- <br />
          <div class="col-md-12">
            <strong class="text-danger">Informacion del terapeuta</strong>
          </div> -->
          <div class="col-md-12">
            <strong v-if="actionModal === 'detalle'">
              <i class="fa fa-user"></i>
              {{ eventoSeleccionado.extendedProps.nombreTerapeuta }}
              <button
                v-if="
                  eventoSeleccionado.extendedProps.tipo != 'CYT' &&
                  eventoSeleccionado.extendedProps.estadoEvento === 3"
                class="btn btn-xs btn-success btn-fill"
                @click="actionModal = 'actualizar terapeuta'"
              >
                Actualizar terapeuta
              </button>
            </strong>
            <br />
            <div
              class="changeUser"
              v-if="actionModal == 'actualizar terapeuta'"
            >
              <div class="row">
                <div class="col-md-12">
                  <strong>Modificar terapeuta de la sesión</strong>
                  <select class="form-control" v-model="terapeutaActualizar">
                    <option
                      v-for="Terapeuta in arrayTerapeutas"
                      :key="Terapeuta.usuario"
                      :value="Terapeuta.usuario"
                      :disabled="
                        Terapeuta.usuario ==
                        eventoSeleccionado.extendedProps.usuarioTerapeuta
                      "
                    >
                      {{ Terapeuta.nombres }} {{ Terapeuta.apellidos }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <small>
              <i class="fa fa-file"></i>
              <strong
                v-if="eventoSeleccionado.extendedProps.tipo == 'Evaluacion'"
              >
                Evaluación</strong
              >
              <strong v-else>Terapia</strong>
              
            </small>
            <br>
            <small v-if="eventoSeleccionado.extendedProps.tipo == 'GTSL'">
              <i class="fa fa-eye"></i> <span style="color:red">Observación:</span>  Gestión sin logro de objetivo
            </small>
            <br />
            <small v-if="eventoSeleccionado.extendedProps.especialidad != null">
              <i class="fa fa-file"></i>
              <strong>{{
                eventoSeleccionado.extendedProps.especialidad
              }}</strong>
            </small>
          </div>
        </div>
        <div
          class="row"
          v-if="
            eventoSeleccionado.extendedProps.tipo === 'CYT' &&
            eventoSeleccionado.extendedProps.estadoEvento === 3
          "
        >
          <br />
          <div class="col-md-12">
            <div class="cardcyt">
              <div class="row">
                <div class="col-md-12">
                  <strong class="text-gray" style="font-size: 17px"
                    >Esta sesión es un CYT, solo debe hacer click en aceptar
                    para hacerlo efectivo</strong
                  >
                  <p>
                    <br />
                    Para hacer efectivo el <strong>CYT</strong> ahora solo debe
                    hacer click en aceptar y la información será registrada, en
                    caso de que no se haya dado el <strong>CYT</strong> solo
                    debe hacer click en cancelar.
                  </p>
                  <p>
                    <button
                      @click="aceptarCYT()"
                      class="btn btn-secondary btn-fill"
                      style="border-radius: 5px"
                    >
                      <strong style="color: white">Aceptar CYT</strong>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-footer" v-if="eventoSeleccionado != ''">
        <div class="row">
          <center>
            <div
              class="col-md-12"
              v-if="
                eventoSeleccionado.extendedProps.estadoEvento === 1 &&
                actionModal === 'detalle'
              "
            >
              <strong style="color: green"> Esta sesión fue realizada </strong>
            </div>
            <div
              class="col-md-12"
              v-if="
                eventoSeleccionado.extendedProps.estadoEvento === 2 &&
                actionModal === 'detalle'
              "
            >
              <strong style="color: red"> Esta sesión fue cancelada </strong>
            </div>
            <div
              class="row"
              style="padding-left: 8px"
              v-if="
                eventoSeleccionado.extendedProps.estadoEvento === 3 &&
                actionModal === 'detalle'
              "
            >
              <div class="col-md-8">
                <select class="form-control" v-model="motivoCancelacion">
                  <option value="">Seleccione motivo de cancelación...</option>
                  <option
                    v-for="item in motivoCancelarOptions"
                    :key="item"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <button
                  style="border-radius: 5px"
                  @click="cancelarEvento()"
                  class="btn btn-danger btn-fill"
                >
                  <strong style="color: white">Cancelar sesión</strong>
                </button>
              </div>
            </div>
            <div class="row" v-if="actionModal === 'actualizar horario'">
              <center>
                <button
                  @click="actionModal = 'detalle'"
                  class="btn btn-secondary btn-fill"
                  style="border-radius: 5px"
                >
                  Cancelar
                </button>
                <button
                  class="btn btn-success btn-fill"
                  style="border-radius: 5px"
                  @click="actualizarHorario()"
                >
                  Actualizar horario
                </button>
              </center>
            </div>
            <div class="row" v-if="actionModal === 'actualizar terapeuta'">
              <center>
                <button
                  @click="actionModal = 'detalle'"
                  class="btn btn-secondary btn-fill"
                  style="border-radius: 5px"
                >
                  Cancelar
                </button>
                <button
                  class="btn btn-success btn-fill"
                  style="border-radius: 5px"
                  @click="actualizarTerapeuta()"
                >
                  Actualizar terapeuta
                </button>
              </center>
            </div>
          </center>
        </div>
      </footer>
    </modal>
    <modal
      name="mensaje"
      id="modal"
      height="auto"
      width="500"
      :clickToClose="false"
      style="text-align: center"
    >
      <header class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-7">
            <strong>Registro exitoso!</strong>
          </div>
          <div class="col-md-5 pull-lefth">
            <button
              @click="cerrarModal('mensaje')"
              type="button"
              class="close btn btn-danger btn-simple btn-icon"
              data-dismiss="modal"
              aria-label="Close"
              style="color: red"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </header>
      <section
        class="modal-body"
        style="padding: 8px; text-align: center; padding: 60px 0"
      >
        <p style="font-size: xx-large; font-weight: bold">{{ mensaje }}</p>
      </section>
      <footer class="modal-footer">
        <div class="row">
          <center>
            <div class="col-md-12">
              <button
                style="border-radius: 5px"
                @click="recargarVentana()"
                class="btn btn-danger btn-fill"
              >
                <strong style="color: white">Cerrar</strong>
              </button>
            </div>
          </center>
        </div>
      </footer>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import esLocale from "@fullcalendar/core/locales/es";
import listPlugin from "@fullcalendar/list";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { toMoment } from "@fullcalendar/moment";
import googleCalendarPlugin from "@fullcalendar/google-calendar";
import crearAlerta from "../../global-services/crearAlerta";

export default {
  data() {
    return {
      ip: "https://avanti-erp.com",
      terapeutaEventos: "todos",
      desde: 7,
      formPaciente: {
        criterio: "paciente.PacApe1",
        busqueda: "",
      },
      pacienteSeleccionado: {
        documento: "",
        nombre: "",
        ide: "",
      },
      servicioSeleccionado: {
        id: "",
        codigo: "",
        sesionesAutorizadas: "",
        sesionesProgramadas: "",
        fechaVencimiento: "",
        tipo: "",
        entidad: ""
      },
      actualizarhorainicio: "",
      actualizarhorafin: "",
      eventoSeleccionado: [],
      diasProgramacion: {
        lunes: {
          horainicio: "",
          horafin: "",
        },
        martes: {
          horainicio: "",
          horafin: "",
        },
        miercoles: {
          horainicio: "",
          horafin: "",
        },
        jueves: {
          horainicio: "",
          horafin: "",
        },
        viernes: {
          horainicio: "",
          horafin: "",
        },
        sabado: {
          horainicio: "",
          horafin: "",
        },
        domingo: {
          horainicio: "",
          horafin: "",
        },
      },
      programacionIndividual: {
        fecha: "",
        horainicio: "",
        horafin: "",
        tipo: "",
        lugar: "",
        valorSesion: "",
        copago: ""
      },
      arrayProgramacionEspecialidad: [],
      contadorSesionesEspecialidad: 0,
      arrayPacientes: [],
      arrayServiciosDisponibles: [],
      arrayServiciosDisponiblesBackup: [],
      arrayServiciosConTarifa: [],
      arrayTerapeutas: [],
      iniciosesiones: "",
      finsesiones: "",
      terapeutaProgramar: "",
      arrayEventos: [],
      modal: 0,
      formato: 1,
      actionModal: "detalle",
      terapeutaActualizar: "",
      labelEspecialidad: {
        null: 'No aplica',
        0: 'No aplica',
        6: 'Psicologia',
        2: 'Fisioterapia',
        3: 'Fonoaudiologia',
        4: 'Terapia ocupacional'
      },

      // calendar
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
        listPlugin,
        googleCalendarPlugin,
      ],
      headers: {
        left: "prev,today,next",
        center: "title",
        // right: "dayGridMonth,timeGridWeek,listWeek,timeGridDay",
        right: "title",
      },
      type: ["", "info", "success", "warning", "danger"],
      mensaje: "",
      motivoCancelacion: "",
      motivoCancelarOptions: [
        "Cambio de terapeuta",
        "Clima",
        "Colegio",
        "Cuarentena / Posible COVID",
        "Decisión familia",
        "Enfermedad / Cita médica",
        "Evento Social / Extracurricular",
        "Error en la programación / Error administrativo",
        "Exigencias en la programación",
        "Falta de transporte",
        "Falta orden médica",
        "Hora programada no sirve",
        "No disponibilidad AVANZA",
        "Puntualidad / Trafico / Lejania con centro",
        "Retiro voluntario",
        "Servicios públicos",
        "Sin disponibilidad acudiente",
        "Viaje / Vacaciones",
        "Otros",
      ],
    };
  },
  methods: {
    eliminarProgramacionDeLaLista: function( index ){
      this.contadorSesionesEspecialidad = this.contadorSesionesEspecialidad - this.arrayProgramacionEspecialidad[index].sesiones;
      this.arrayProgramacionEspecialidad.splice(index, 1);
    },
    adicionarProgramacion: function(){

      if(this.terapeutaProgramar == "" || this.programacionIndividual.horainicio == ""
        || this.programacionIndividual.horafin == "" || this.programacionIndividual.fecha == "" ||
        this.programacionIndividual.tipo == "" || this.programacionIndividual.lugar == "" ||
        this.programacionIndividual.valorSesion == ""
      ){
        this.$notify(crearAlerta("danger", "Debes completar todos los campos"));
        return;
      }

      const CANTIDADSESIONES = this.calcularMinutos(this.programacionIndividual.horainicio, this.programacionIndividual.horafin);

      if(CANTIDADSESIONES > 6){
        this.$notify(crearAlerta("danger", 'No puedes programar más de 6 sesiones continuas'));
        return;
      }


      if((CANTIDADSESIONES + this.contadorSesionesEspecialidad) > this.servicioSeleccionado.sesionesAutorizadas){
        this.$notify(crearAlerta("danger", "La cantidad de sesiones supera la cantidad de sesiones autorizadas"));
        return;
      }

      

      this.arrayProgramacionEspecialidad.push({
          horainicio: this.programacionIndividual.horainicio,
          horafin: this.programacionIndividual.horafin,
          fecha: this.programacionIndividual.fecha,
          sesiones: this.calcularMinutos(
            this.programacionIndividual.horainicio,
            this.programacionIndividual.horafin
          ),
          tipo: this.programacionIndividual.tipo,
          terapeuta: this.terapeutaProgramar,
          servicio: this.servicioSeleccionado.id,
          servicioTipo: this.servicioSeleccionado.tipo,
          paciente: this.pacienteSeleccionado.ide,
          lugar: this.programacionIndividual.lugar,
          valor: this.servicioSeleccionado.tipo == 'particular' ? this.programacionIndividual.valorSesion : this.programacionIndividual.valorSesion.tarifa,
          copago : this.programacionIndividual.copago,
          sede: localStorage.getItem("sede"),
      });

      this.contadorSesionesEspecialidad = this.contadorSesionesEspecialidad + CANTIDADSESIONES;
      this.programacionIndividual.horainicio = "";
      this.programacionIndividual.horafin = "";
      this.programacionIndividual.valorSesion = "";
      this.terapeutaProgramar = "";
    },
    recargarVentana: function () {
      location.reload();
    },
    buscarPaciente: function () {
      this.$modal.show("carga");
      const { criterio, busqueda } = this.formPaciente;
      const rol = localStorage.getItem("rol");
      const sede = rol === 1 ? localStorage.getItem("sede") : "todas";
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/pacientesHC/${criterio}/${busqueda}/${sede}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          this.arrayPacientes = res.data.data;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    guardarMensaje: function (mensaje) {
      this.mensaje = mensaje;
      this.$modal.hide("ingresar_programacion");
      this.$modal.show("mensaje");
    },
    obtenerDatosSelect: function () {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/pacientesHC/${criterio}/${busqueda}/${sede}`;
    },
    enviarProgramacion: async function () {
      let VECTORPROGRAMACION = [];

      if(this.formato === 3){
        if (this.terapeutaProgramar == "") {
          let mensaje = "Debes seleccionar un terapeuta";
          this.$notify(crearAlerta("danger", mensaje));
          this.$modal.hide("carga");
          return;
        }

        if(this.servicioSeleccionado.tipo == 'particular' && this.programacionIndividual.valorSesion == ''){
          this.$notify(crearAlerta("danger", 'Debe registrar el valor por sesión a cobrar'));
          return;
        }

        if(this.servicioSeleccionado.tipo != 'particular' && this.programacionIndividual.valorSesion.tarifa == ''){
          this.$notify(crearAlerta("danger", 'Debe registrar el valor por sesión a cobrar'));
          return;
        }
      }

      

      if (this.formato === 1) {
        if (this.programacionIndividual.fecha === "") {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `
                <div>
                  <p>Notificación</p>  
                  <strong>Debes ingresar la fecha de inicio de las sesiones</strong>
                </div>
              `,
            },
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          this.$modal.hide("carga");
          return;
        }
        if (
          this.programacionIndividual.horainicio === "" ||
          this.programacionIndividual.horafin === ""
        ) {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `
                <div>
                  <p>Notificación</p>  
                  <strong>Ingrese la hora de inicio y final de la sesión</strong>
                </div>
              `,
            },
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          this.$modal.hide("carga");
          return;
        }
        const SESIONESDISPONIBLES =
          this.servicioSeleccionado.sesionesAutorizadas;
        const SESIONES = this.calcularMinutos(
          this.programacionIndividual.horainicio,
          this.programacionIndividual.horafin
        );

        if(SESIONES > 6){
          this.$notify(crearAlerta("danger", 'No puedes programar más de 6 sesiones continuas'));
          return;
        }

        const SESIONESVALIDAR = SESIONES;
        if (SESIONESVALIDAR > SESIONESDISPONIBLES) {
          this.$notify({
            component: {
              template: `
                  <div>
                    <p>Notificación</p>  
                    <strong>Las sesiones que quiere programar superan la cantidad de sesiones disponibles en este servicio.</strong>
                  </div>
                `,
            },
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          return;
        }

        VECTORPROGRAMACION.push({
          horainicio: this.programacionIndividual.horainicio,
          horafin: this.programacionIndividual.horafin,
          fecha: this.programacionIndividual.fecha,
          sesiones: this.calcularMinutos(
            this.programacionIndividual.horainicio,
            this.programacionIndividual.horafin
          ),
          tipo: this.programacionIndividual.tipo,
          terapeuta: this.terapeutaProgramar,
          servicio: this.servicioSeleccionado.id,
          servicioTipo: this.servicioSeleccionado.tipo,
          paciente: this.pacienteSeleccionado.ide,
          lugar: this.programacionIndividual.lugar,
          valor: this.servicioSeleccionado.tipo == 'particular' ? this.programacionIndividual.valorSesion : this.programacionIndividual.valorSesion.tarifa,
          copago : this.programacionIndividual.copago,
          sede: localStorage.getItem("sede"),
        });
      } else if (this.formato === 2){
        if (this.iniciosesiones === "" && this.formato === 2) {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `
                <div>
                  <p>Notificación</p>  
                  <strong>Debes ingresar la fecha de inicio de las sesiones</strong>
                </div>
              `,
            },
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          this.$modal.hide("carga");
          return;
        }
        if (Object.keys(this.diasProgramacion).length == 0) {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `
                <div>
                  <p>Notificación</p>  
                  <strong>No se ha programado ningún día</strong>
                </div>
              `,
            },
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          this.$modal.hide("carga");
          return;
        }
        let contador = 0;
        for (const dia in this.diasProgramacion) {
          if (
            this.diasProgramacion[dia].horainicio != "" &&
            this.diasProgramacion[dia].horafin
          ) {
            contador = contador + 1;
          }
        }
        if (contador == 0) {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `
                <div>
                  <p>Notificación</p>  
                  <strong>No se ha programado ningún día</strong>
                </div>
              `,
            },
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          this.$modal.hide("carga");
          return;
        }
        VECTORPROGRAMACION = await this.crearVectorProgramacion();
      }else{
        VECTORPROGRAMACION = this.arrayProgramacionEspecialidad;
      }

     
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };

      const BASE_URL = `${this.ip}/api/programar-sesiones-calendario`;
      axios
        .post(BASE_URL, { items: VECTORPROGRAMACION }, config)
        .then((res) => {
          if (res.data.status === false) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `
                  <div>
                    <p>Notificación</p>  
                    <strong>${res.data.mensaje}</strong>
                  </div>
                `,
              },
              icon: "",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type[color],
            });
            this.$modal.hide("carga");
            return;
          }

          if (this.formato == 2) {
            this.guardarMensaje(res.data.mensaje);
            this.setearEventos();
          } else {
            this.guardarMensaje("Sesión registrada con éxito");
            this.setearEventos();
          }
          this.$modal.hide("carga");
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(VECTORPROGRAMACION);
          console.log(err);
        });
    },
    setearEventos() {
      if (this.terapeutaEventos === "todos") {
        this.obtenerEventos("sede");
      } else {
        this.obtenerEventos("terapeuta");
      }
    },
    obtenerEventos: function (tipoBusqueda) {
      const CRITERIO =
        tipoBusqueda === "sede"
          ? "programacion.sede"
          : "programacion.terapeuta";
      const BUSQUEDA =
        tipoBusqueda === "sede"
          ? localStorage.getItem("sede")
          : this.terapeutaEventos;
      const DESDE = this.desde;
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/obtener-eventos-calendario/${CRITERIO}/${BUSQUEDA}/${DESDE}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          let data = res.data.data;
          let events = [];
          data.forEach((element) => {
            events.push({
              title:
                element.tipo === "Terapia"
                  ? `${element.nombrePaciente} ${element.apellidoPaciente} ( ${element.lugar} )`
                  : element.tipo === "CYT"
                  ? `${element.nombrePaciente} ${element.apellidoPaciente} - CYT ( ${element.lugar} )`
                  : element.tipo === "Evaluacion"  ? `${element.nombrePaciente} ${element.apellidoPaciente} - EVALUACIÓN ( ${element.lugar} )` :
                  `${element.nombrePaciente} ${element.apellidoPaciente} ( ${element.lugar} )`,
              // description: 'Terapia',
              start: `${element.fecha}T${element.horaInicio}`,
              end: `${element.fecha}T${element.horaFin}`,
              color:
                element.estadoEvento === 3
                  ? "blue"
                  : element.estadoEvento === 2
                  ? "red"
                  : "green",
              extendedProps: {
                nombreTerapeuta: `${element.nombreTerapeuta} ${element.apellidoTerapeuta}`,
                usuarioTerapeuta: element.terapeuta,
                pacienteId: element.usuarioId,
                especialidad: element.especialidad,
                autorizacion: element.autorizacion,
                fecha: element.fecha,
                tipo: element.tipo,
                horainicio: element.horaInicio,
                horafin: element.horaFin,
                documentoPaciente: element.documentoPaciente,
                cantidadSesiones: parseInt(element.sesionesCantidad),
                estadoEvento: element.estadoEvento,
                idEvento: element.idEvento,
              },
            });
          });

          this.arrayEventos = events;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    verEvento: function (arg) {
      const EVENT = arg.event;
      this.eventoSeleccionado = EVENT;
      this.$modal.show("detalle_terapia");
    },
    cancelarEvento: function () {
      const EVENT = this.eventoSeleccionado.extendedProps;
      const CANTIDADSESIONES =
        this.eventoSeleccionado.extendedProps.cantidadSesiones;
      const AUTORIZACION = this.eventoSeleccionado.extendedProps.autorizacion;
      const MOTIVOCAN = this.motivoCancelacion;
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/cancelar-evento-calendario`;
      axios
        .post(
          BASE_URL,
          { EVENT, CANTIDADSESIONES, AUTORIZACION, MOTIVOCAN },
          config
        )
        .then((res) => {
          this.$modal.hide("carga");
          if (res.data.status === false) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<div>
                    <p> Notificación<p>
                    <p> <strong>${res.data.mensaje}</strong></p>
                  </div>`,
              },
              icon: "",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
            this.$modal.hide("carga");
          } else {
            this.motivoCancelacion = "";
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<div>
                    <p> Notificación <p>
                    <p> <strong>${res.data.mensaje}</strong></p>
                  </div>`,
              },
              icon: "",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
            this.setearEventos();
            this.$modal.hide("carga");
            this.$modal.hide("detalle_terapia");
          }
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    aceptarCYT: function () {
      const EVENT = this.eventoSeleccionado.extendedProps;
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/aceptar-cyt-calendario`;
      axios
        .post(BASE_URL, { EVENT }, config)
        .then((res) => {
          this.$modal.hide("carga");
          if (res.data.status === true) {
            this.$notify(crearAlerta("success", res.data.mensaje));
            this.cerrarModal("detalle_terapia");
            this.setearEventos();
          }
        })
        .catch((err) => {
          this.$modal.hide("carga");
          this.$notify(crearAlerta("danger", mensaje));
          console.log(err);
        });
    },
    actualizarHorario: function () {
      const EVENT = this.eventoSeleccionado.extendedProps;
      const HORAINICIO = this.actualizarhorainicio;
      const HORAFIN = this.actualizarhorafin;
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/actualizar-horario-evento`;
      axios
        .post(BASE_URL, { EVENT, HORAINICIO, HORAFIN }, config)
        .then((res) => {
          this.$modal.hide("carga");
          if (res.data.status === true) {
            this.actualizarhorainicio = "";
            this.actualizarhorafin = "";
            this.$notify(crearAlerta("success", res.data.mensaje));
            this.cerrarModal("detalle_terapia");
            this.setearEventos();
          }
        })
        .catch((err) => {
          this.$modal.hide("carga");
          this.$notify(crearAlerta("danger", mensaje));
          console.log(err);
        });
    },
    actualizarTerapeuta: function () {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const EVENT = this.eventoSeleccionado.extendedProps;
      const TERAPEUTA = this.terapeutaActualizar;
      const BASE_URL = `${this.ip}/api/actualizar-terapeuta-evento`;
      this.$modal.show("carga");
      axios
        .post(BASE_URL, { EVENT, TERAPEUTA }, config)
        .then((res) => {
          this.$modal.hide("carga");
          if (res.data.status === true) {
            this.terapeutaActualizar = "";
            this.$notify(crearAlerta("success", res.data.mensaje));
            this.cerrarModal("detalle_terapia");
            this.setearEventos();
          }
        })
        .catch((err) => {
          this.$modal.hide("carga");
          this.$notify(crearAlerta("danger", mensaje));
          console.log(err);
        });
    },
    buscarServiciosDisponibles: function () {
      this.$modal.show("carga");
      const { ide } = this.pacienteSeleccionado;
      const date = this.calcularFechaActual();
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/paciente/serviciosDisponibles/${ide}/${date}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          this.arrayServiciosDisponibles = res.data.items;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    seleccionarPaciente: function (paciente) {
      const { PacNom1, PacApe1, PacNumDoc, PacIdeUsu } = paciente;
      this.pacienteSeleccionado.nombre = `${PacNom1} ${PacApe1}`;
      this.pacienteSeleccionado.documento = PacNumDoc;
      this.pacienteSeleccionado.ide = PacIdeUsu;
      this.arrayPacientes = [];
      this.buscarServiciosDisponibles();
    },
    seleccionarServicio: function (servicio) {
      const { id, bolsa, codigo, fechaVencimiento, tipo, entidad } = servicio;
      this.servicioSeleccionado.id = id;
      this.servicioSeleccionado.codigo = codigo;
      this.servicioSeleccionado.sesionesAutorizadas = bolsa;
      this.servicioSeleccionado.sesionesProgramadas = 0;
      this.servicioSeleccionado.fechaVencimiento = fechaVencimiento;
      this.servicioSeleccionado.tipo = tipo;
      this.servicioSeleccionado.entidad = entidad;
      this.arrayServiciosDisponibles = [];
      this.obtenerServiciosConTarifa(entidad);
      this.selectTerapeuta(1);
    },
    selectTerapeuta: function (especialidad) {
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/selectTerapeutasProgramar/${especialidad}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          this.arrayTerapeutas = res.data.data;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    abrirModal: function () {
      this.modal = 1;
      this.$modal.show("ingresar_programacion");
    },
    cerrarModal: function (modal) {
      this.$modal.hide(modal);
      if (modal == "ingresar_programacion") {
        this.recargarVentana();
      }

      if (modal == "detalle_terapia") {
        this.actionModal = "detalle";
      }
    },
    calcularFechaActual: function () {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    calcularDiasProgramar: function () {
      let arrayDiasProgramacion = [];
      let allDays = this.diasProgramacion;
      for (var dia in allDays) {
        if (allDays.hasOwnProperty(dia)) {
          const horainicio = allDays[dia].horainicio;
          const horafin = allDays[dia].horafin;

          if (horainicio != "" && horafin != "") {
            arrayDiasProgramacion.push({ horainicio, horafin });
          } else {
            arrayDiasProgramacion.push(0);
          }
        }
      }
    },
    crearVectorProgramacion: async function () {
      let SESIONESDISPONIBLES = this.servicioSeleccionado.sesionesAutorizadas;
      const FECHAINICIO = this.iniciosesiones;
      const FECHAFIN = this.finsesiones;
      const FECHAACTUAL = this.calcularFechaActual();
      const DIASPROGRAMACION = this.diasProgramacion;
      const DIASDISPONIBLESPROGRAMAR = this.obtenerDiasEntreFechas(
        FECHAINICIO,
        FECHAFIN
      );

      let vectorprogramacion = [];
      for (let index = 0; index < DIASDISPONIBLESPROGRAMAR.length; index++) {
        const ELEMENT = DIASDISPONIBLESPROGRAMAR[index];
        const POSITION = ELEMENT["DIASEMANA"];
        const VALIDARDIA = DIASPROGRAMACION[POSITION];

        if (
          VALIDARDIA.horainicio != "" &&
          VALIDARDIA.horafinicio != "" &&
          ELEMENT["FECHAFORMATEADA"] > FECHAACTUAL
        ) {
          const { horainicio, horafin } = VALIDARDIA;
          const { DIASEMANA, FECHAFORMATEADA } = ELEMENT;
          const CANTIDADSESIONES = this.calcularMinutos(horainicio, horafin);

          if (SESIONESDISPONIBLES - CANTIDADSESIONES >= 0) {
            vectorprogramacion.push({
              horainicio: horainicio,
              horafin: horafin,
              dia: DIASEMANA,
              fecha: FECHAFORMATEADA,
              sesiones: CANTIDADSESIONES,
              terapeuta: this.terapeutaProgramar,
              servicio: this.servicioSeleccionado.id,
              servicioTipo: this.servicioSeleccionado.tipo,
              tipo: "Terapia",
              lugar: this.programacionIndividual.lugar,
              valor: this.servicioSeleccionado.tipo == 'particular' ? this.programacionIndividual.valorSesion : this.programacionIndividual.valorSesion.tarifa,
              copago : this.programacionIndividual.copago,
              paciente: this.pacienteSeleccionado.ide,
              sede: localStorage.getItem("sede"),
            });
            SESIONESDISPONIBLES = SESIONESDISPONIBLES - CANTIDADSESIONES;
          }
        }
      }

      return vectorprogramacion;
    },
    obtenerDiasEntreFechas: function (fechaInicio, fechaFin) {
      let diasEntreFechas = [];

      const inicio = new Date(fechaInicio + "T12:00:00-05:00");
      const fin = new Date(fechaFin + "T12:00:00-05:00");

      var fechaActual = inicio;
      while (fechaActual <= fin) {
        const año = fechaActual.getFullYear();
        const mes = fechaActual.getMonth() + 1;
        const dia = fechaActual.getDate();
        const FECHAFORMATEADA =
          año +
          "-" +
          (mes < 10 ? "0" : "") +
          mes +
          "-" +
          (dia < 10 ? "0" : "") +
          dia;

        const DIASEMANA = this.obtenerNombreDiaSemana(FECHAFORMATEADA);
        diasEntreFechas.push({ FECHAFORMATEADA, DIASEMANA });
        fechaActual.setDate(fechaActual.getDate() + 1);
      }
      console.log(diasEntreFechas, "dias programacion");
      return diasEntreFechas;
    },
    obtenerNombreDiaSemana: function (fecha) {
      var diasSemana = [
        "lunes",
        "martes",
        "miercoles",
        "jueves",
        "viernes",
        "sabado",
        "domingo",
      ];
      var diaSemana = new Date(fecha).getDay();
      var nombreDia = diasSemana[diaSemana];
      return nombreDia;
    },
    calcularMinutos(inicio, fin) {
      const horaInicial = this.devolverMinutos(inicio);
      const horaFinal = this.devolverMinutos(fin);

      if (horaInicial < horaFinal) {
        let sesiones = (horaFinal - horaInicial) / 30;

        return Math.trunc(sesiones);
      }
    },
    devolverMinutos(horaMinutos) {
      return (
        parseInt(horaMinutos.split(":")[0]) * 60 +
        parseInt(horaMinutos.split(":")[1])
      );
    },
    validarHoraInicio() {
      const { horainicio } = this.programacionIndividual;
      if (horainicio < "07:00" || horainicio > "18:00") {
        this.$notify(crearAlerta("danger", "El rango de horas de programación es de 7:00 am y 6:00pm"))
        this.programacionIndividual.horainicio = "";
        return;
      }
    },
    validarHoraFin() {
      const { horafin } = this.programacionIndividual;
      if (horafin < "07:00" || horafin > "18:00") {
        this.$notify(crearAlerta("danger", "El rango de horas de programación es de 7:00 am y 6:00pm"))
        this.programacionIndividual.horafin = "";
        return;
      }
    },
    adicionarHoras: function () {
      const horainicio = this.actualizarhorainicio;
      const minutesAdd =
        this.eventoSeleccionado.extendedProps.cantidadSesiones * 30;

      let date = new Date("1970-01-01T" + horainicio);
      date.setMinutes(date.getMinutes() + minutesAdd);
      let newHour = date.toTimeString().slice(0, 5);

      this.actualizarhorafin = newHour + ":00";
    },
    obtenerServiciosConTarifa: function(entidad){
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/servicios-tarifa/${entidad}`;
      axios.get(BASE_URL, config).then((res) =>{
        this.arrayServiciosConTarifa = res.data.data;
      }).catch((err) =>{
        console.log(err);
      });
    }
  },
  mounted() {
    this.obtenerEventos("sede");
    this.selectTerapeuta(1);
    window.document.title = "AVANTI | Programación";
  },
  components: {
    FullCalendar,
  },
};
</script>
<style scoped>
.cardcyt {
  background-color: rgb(242, 242, 242);
  margin-top: 5px;
  border-radius: 7px;
  padding: 12px;
}

@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@fullcalendar/list/main.css";
</style>



// WEBPACK FOOTER //
// src/components/Programacion/programacion.vue